<template>
  <section id="login">
    <h1><strong>facilitéo</strong> <span class="small"> facilitateur de visibilité</span></h1>
    <form @submit.prevent="handleSendEmail">
      <f-card>
        <template slot="header"><div class="header">Mot de passe oublié</div></template>
        <template>
          <section class="main">
            <div class="logo"></div>
            <div class="input">
              <span>Merci de saisir l'adresse email associée à votre compte</span>
              <ab-input id="email" type="email" class="mandatory" label="Email" v-model="email"></ab-input>
              <span>Vous recevrez un mail vous invitant à le réinitialiser</span>
              <div class="buttons">
                <router-link :to="{ name: 'Login' }" class="btn-action">Annuler</router-link>
                <ab-button type="submit" class="primary">Valider</ab-button>
              </div>
            </div>
          </section>
        </template>
      </f-card>
    </form>
  </section>
</template>

<script>
  import FCard from '@/components/layout/card/f-card.vue';
  import AbInput from '@/components/form/input/ab-input.vue';
  import AbButton from '@/components/form/button/ab-button.vue';
  // Import error message files
  import messages from '@/messages/messages.js';

  export default {
    name: 'PasswordForgotten',
    components: {
      FCard,
      AbInput,
      AbButton,
    },
    data() {
      return {
        email: '',
      };
    },
    methods: {
      async handleSendEmail(e) {
        const email = this.$el.querySelector('#email input');

        email.classList.remove('error');
        if (this.email != '') {
          const data = await this.$store.dispatch('requestPwdChange', {
            email: this.email,
          });
          // Case else done in api.js
          // if (data && data.token) {
          // TODO verifier si la connexion marche
          if (data) {
            this.displayToast({ message: messages.selectors.PasswordForgotten.custom.success });
            return this.$router.push({ path: "/login" });
          }
        } else {
          email.classList.add('error');
          this.displayToast({ message: messages.selectors.PasswordForgotten.custom.mandatory, mode: 'error' });
        }
      },
    },
  }
</script>

<style scoped>
  #login {
    background-image: url('/images/logo-filigram.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h1 {
    font-size: 28px;
    color: #636A79;
    text-align: center;
    margin-bottom: 3rem;
  }
  .small {
    font-size: 20px;
    color: #707683;
  }
  .main { display: flex; }
  .main .logo {
    width: 20%;
    background-color: var(--app-black-color);
    background-image: url('/images/logo-white.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 70%;
  }

  .f-card {
    padding: 0;
    width: 35%;
    min-width: 46rem;
    overflow: hidden;
  }
  .f-card .header {
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.01em;
    font-family: var(--app-font-medium);
    padding: 0.8rem 0.8rem;
  }
  .main .input {
    flex: 1;
    padding: 2rem;
  }
  .main .input .ab-input { margin: 2rem 0; }
  .buttons {
    margin-top: 3rem;
    display: flex;
    justify-content: space-between;
  }
</style>
